import * as React from 'react';

import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { routes } from 'utils/routing';

import { ModalContent } from '../styled';

import {
  ButtonContainer,
  Container,
  LoadingText,
  StyledActionButton,
  StyledActionLink,
} from './styled';
import { IDeliveryUnavailableProps } from './types';

/**
 *
 * DeliveryUnavailable informs the guest that the address they entered
 * is unable to receive delivery at this time
 *
 */

export const DeliveryUnavailable: React.FC<React.PropsWithChildren<IDeliveryUnavailableProps>> = ({
  address,
  close,
}) => {
  const { formatMessage } = useIntl();

  useLogUserErrorMessage({
    message: 'delivery-unavailable-for-address',
    severity: LogUserErrorSeverity.Irrecoverable,
  });

  return (
    <Container testID="delivery-unavailable-for-address">
      <ModalContent>
        <LoadingText>{formatMessage({ id: 'cannotDeliveryTo' })}</LoadingText>
        <LoadingText>{address}</LoadingText>
        <ButtonContainer>
          <StyledActionLink fullWidth to={routes.storeLocator}>
            {formatMessage({ id: 'orderPickup' })}
          </StyledActionLink>
        </ButtonContainer>
        <ButtonContainer>
          <StyledActionButton
            testID="use-different-address"
            fullWidth
            onPress={close}
            variant={ActionButtonVariants.OUTLINE}
          >
            {formatMessage({ id: 'useDifferentAddress' })}
          </StyledActionButton>
        </ButtonContainer>
      </ModalContent>
    </Container>
  );
};
